import { render } from "./StoreProducts.vue?vue&type=template&id=380c4da1&scoped=true"
import script from "./StoreProducts.vue?vue&type=script&lang=js"
export * from "./StoreProducts.vue?vue&type=script&lang=js"

import "./StoreProducts.vue?vue&type=style&index=0&id=380c4da1&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380c4da1"]])

export default __exports__